/* eslint-disable max-len */

import RvnQuestion from 'images/coin-pages/questions/rvn.svg'

import { ICoinPageData } from '../types'

export const rvnPage: ICoinPageData = {
  title: 'coin_856',
  description: 'coin_857',
  // description: 'coin_858',
  questionsBlock: {
    image: RvnQuestion,
    questions: [
      {
        title: 'coin_859',
        answer: 'coin_860',
      },
      {
        title: 'coin_861',
        answer: 'coin_862',
      },
      {
        title: 'coin_863',
        answer: 'coin_864',
      },
      {
        title: 'coin_865',
        answer: 'coin_866',
      },
      {
        title: 'coin_867',
        answer: 'coin_868',
      },
    ],
  },
  whatIs: {
    text: ['coin_872', 'coin_873'],
    paragraphs: [
      {
        title: 'coin_869',
        text: ['coin_874'],
      },
      {
        title: 'coin_870',
        text: ['coin_875', 'coin_876', 'coin_877', 'coin_878'],
      },
      {
        title: 'coin_871',
        text: ['coin_879', 'coin_880'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/rvn-crypto-loans-efficient-way-to-amplify-your-holdings/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/10/integration-33CR_EARN1-2.png',
        imageAlt: 'Ravencoin (RVN) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/08/Screenshot_21-1.png',
        imageAlt: 'Ravencoin (RVN) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-platform-coinrabbit/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Ravencoin (RVN) review 7',
      },
    ],
  },
}
